import { render, staticRenderFns } from "./ScanComponent.vue?vue&type=template&id=38a6bce4&"
import script from "./ScanComponent.vue?vue&type=script&lang=ts&"
export * from "./ScanComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ScanComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow})
